var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLottomaticaservizi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.3 1000H271.7C122.3 1000 0 877.7 0 728.3V271.7C0 122.3 122.3 0 271.7 0H728.3C877.7 0 1000 122.3 1000 271.7V728.3C1000 877.7 877.7 1000 728.3 1000Z",
    fill: "#003594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780 299.3H595.7C584.3 299.3 573.4 303.8 565.3 311.9L440.1 437C434.2 442.9 438.4 452.9 446.7 452.9H648.1C660.9 452.9 671.2 463.3 671.2 476V678.4C671.2 686.7 681.2 690.8 687.1 685L804.2 568C817.4 554.8 824.8 536.9 824.8 518.3V344.2C824.8 319.5 804.8 299.5 780.1 299.5L780 299.3Z",
    fill: "#149EDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.999 700.7H404.299C415.699 700.7 426.599 696.2 434.699 688.1L559.899 563C565.799 557.1 561.599 547.1 553.299 547.1H351.899C339.099 547.1 328.799 536.7 328.799 524V321.6C328.799 313.3 318.799 309.2 312.899 315L195.799 432C182.599 445.2 175.199 463.1 175.199 481.7V655.8C175.199 680.5 195.199 700.5 219.899 700.5L219.999 700.7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLottomaticaservizi);
export default __webpack_public_path__ + "static/media/lottomaticaservizi.e189b49bdd2d0536239b78e8062ea2db.svg";
export { ForwardRef as ReactComponent };